// src/app/services/version-check.service.ts

import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { interval } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class VersionCheckService {
  private http: HttpClient = inject(HttpClient);

  private currentVersion = "";
  private versionCheckUrl = "version.json";
  private checkInterval = 60000; // toutes les 60 secondes

  constructor() {}

  initVersionCheck(): void {
    this.http.get<any>(this.versionCheckUrl).subscribe((versionInfo) => {
      this.currentVersion = versionInfo.version;
    });

    interval(this.checkInterval).subscribe(() => {
      this.http
        .get<any>(this.versionCheckUrl + "?_ts=" + new Date().getTime())
        .subscribe((versionInfo) => {
          const latestVersion = versionInfo.version;
          if (this.currentVersion && latestVersion !== this.currentVersion) {
            console.log(
              "🆕 Nouvelle version détectée. Rechargement...",
              latestVersion
            );
            window.location.reload();
          }
        });
    });
  }
}
